import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';

import styles from './Photo.module.css';

export const Photo = ({ currentState, message = {} }) => {
  const { content, attachments } = message;
  const url = attachments?.[0]?.url;

  const [curMessage, setCurMessage] = useState({ url, content });

  useEffect(() => {
    if (
      (currentState === 'S2' && url !== curMessage?.url) ||
      !curMessage?.url ||
      !url
    ) {
      setCurMessage({ url, content });
    }
  }, [currentState, url, content]);

  return (
    <div className={styles.photoWrapper}>
      <motion.div
        exit={{ scale: 0, transition: { duration: 0.3, delay: 0.5 } }}
        className={styles.bgBlock}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={`${curMessage.url}-question`}
            initial={{ scale: 0 }}
            animate={{ scale: 1, transition: { duration: 0.5, delay: 0.5 } }}
            exit={{ scale: 0, transition: { duration: 0.2, delay: 0.5 } }}
          >
            <div className={styles.bgBlockQuestion}> ?</div>
          </motion.div>
        </AnimatePresence>
      </motion.div>

      <motion.div
        exit={{ x: '-100vw' }}
        transition={{ duration: 0.5, delay: 0.5 }}
        style={{ position: 'relative', zIndex: 2 }}
      >
        <AnimatePresence mode="popLayout">
          {curMessage && (
            <motion.div
              className={styles.imgBlock}
              key={curMessage.url}
              initial={{ x: '50vw' }}
              animate={{ x: currentState === 'S2' ? 0 : '-50vw' }}
              exit={{ x: '-100vw' }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              {curMessage.url && <img src={curMessage.url} alt="" />}

              <div className={styles.text}>
                {curMessage?.content && (
                  <div className={styles.firsLine}>
                    {curMessage?.content.trim()}
                  </div>
                )}
                {/* {textLines[1] && (
                <div className={styles.secondLine}>{textLines[1].trim()}</div>
              )} */}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};
